import React from "react";

export const NA = <span className="text-slate-600 italic">n/d</span>;

const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" }) : null;

export const eur = (v) => `${Number(v || 0).toLocaleString("fr-FR", { maximumFractionDigits: 2 })} €`;

const SRC = { google_ads: "Google Ads", seo: "SEO", ai: "IA", other: "Autre" };

const Verdict = ({ l }) => {
  if (!("qualification" in l)) return NA;
  const map = {
    validated: ["Bon lead", "bg-emerald-500/15 text-emerald-300"],
    unqualified: ["Pas qualifié", "bg-rose-500/15 text-rose-300"],
  };
  const [label, cls] = map[l.qualification] || ["En attente", "bg-amber-500/15 text-amber-300"];
  return (
    <div>
      <span className={`px-2 py-0.5 rounded-full text-[11px] font-semibold ${cls}`}>{label}</span>
      {l.qualified_at && <div className="text-[10px] text-slate-500 mt-1">{fmtDate(l.qualified_at)}</div>}
    </div>
  );
};

const YesNo = ({ v }) =>
  v === undefined || v === null ? NA : (
    <span className={v ? "text-emerald-400 font-semibold" : "text-slate-500"}>{v ? "Oui" : "Non"}</span>
  );

const Table = ({ testid, head, children, empty }) => (
  <div className="overflow-x-auto rounded-2xl border border-slate-800 bg-slate-900/60" data-testid={testid}>
    <table className="w-full text-sm">
      <thead>
        <tr className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b border-slate-800">
          {head.map((h) => <th key={h} className="px-3 py-2.5 font-semibold whitespace-nowrap">{h}</th>)}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
    {empty && <p className="text-center text-slate-500 text-sm py-8">{empty}</p>}
  </div>
);

export const LeadsTable = ({ leads }) => (
  <Table testid="quality-leads-table" empty={leads.length ? null : "Aucun lead sur cette période."}
    head={["Date", "Site", "Type", "Nom", "Mot-clé", "Source", "Verdict", "GCLID", "Envoyé Google Ads"]}>
    {leads.map((l) => (
      <tr key={`${l.site_id}-${l.event_id}`} className="border-b border-slate-800/60 last:border-0 hover:bg-slate-800/30" data-testid={`quality-lead-${l.event_id}`}>
        <td className="px-3 py-2.5 whitespace-nowrap text-slate-300">{fmtDate(l.timestamp) || NA}</td>
        <td className="px-3 py-2.5 whitespace-nowrap text-slate-400">{l.site_host}</td>
        <td className="px-3 py-2.5 whitespace-nowrap">{l.action === "form" ? "Formulaire" : l.action === "phone_click" ? "Appel" : l.action}</td>
        <td className="px-3 py-2.5 whitespace-nowrap text-white">{l.name || l.email || NA}</td>
        <td className="px-3 py-2.5 max-w-[180px] truncate text-slate-400" title={l.keyword || ""}>{l.keyword || NA}</td>
        <td className="px-3 py-2.5 whitespace-nowrap">{SRC[l.source] || l.source || NA}</td>
        <td className="px-3 py-2.5 whitespace-nowrap"><Verdict l={l} /></td>
        <td className="px-3 py-2.5"><YesNo v={l.has_gclid} /></td>
        <td className="px-3 py-2.5"><YesNo v={l.ga_sent} /></td>
      </tr>
    ))}
  </Table>
);

const viaLabel = (o) => {
  if (o.ga_sent === undefined) return NA;
  if (!o.ga_sent) return <span className="text-slate-500">Non</span>;
  const via = { click: "Par clic", call: "Par appel" }[o.ga_via] || "Oui";
  return <span className="text-emerald-400 font-semibold">{via}</span>;
};

export const OrdersTable = ({ orders }) => (
  <Table testid="quality-orders-table" empty={orders.length ? null : "Aucune commande sur cette période."}
    head={["N° commande", "Date", "Montant", "Site", "Contact", "Envoyée Google Ads"]}>
    {orders.map((o) => (
      <tr key={`${o.site_id}-${o.order_id}`} className="border-b border-slate-800/60 last:border-0 hover:bg-slate-800/30" data-testid={`quality-order-${o.order_id}`}>
        <td className="px-3 py-2.5 whitespace-nowrap font-mono text-white">{o.order_id}</td>
        <td className="px-3 py-2.5 whitespace-nowrap text-slate-300">{fmtDate(o.timestamp) || NA}</td>
        <td className="px-3 py-2.5 whitespace-nowrap font-semibold text-white">
          {o.currency === "EUR" ? eur(o.value) : `${o.value} ${o.currency}`}
        </td>
        <td className="px-3 py-2.5 whitespace-nowrap text-slate-400">{o.site_host}</td>
        <td className="px-3 py-2.5 whitespace-nowrap">{{ form: "Formulaire", call: "Appel" }[o.contact_type] || NA}</td>
        <td className="px-3 py-2.5 whitespace-nowrap">{viaLabel(o)}</td>
      </tr>
    ))}
  </Table>
);
